import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import Svg, { Circle } from "react-native-svg";
import { Text } from "@lookiero/sty-psp-ui";
import { Icon, theme } from "@lookiero/sty-psp-ui";
import { style as actionButtonStyle, RADIUS } from "./ActionButton.style";
const SPRING_CONFIG = {
    damping: 25,
    mass: 1,
    stiffness: 300,
};
const BUTTON_ACTIVE_OPACITY = 0.6;
const MESSAGE_SHOWN_TIMEOUT = 800;
var ActionButtonStatus;
(function (ActionButtonStatus) {
    ActionButtonStatus["IDLE"] = "IDLE";
    ActionButtonStatus["ACTIVE"] = "ACTIVE";
    ActionButtonStatus["INACTIVE"] = "INACTIVE";
})(ActionButtonStatus || (ActionButtonStatus = {}));
const ActionButton = ({ text, icon, status, alignment, testID = "action-button", onPress }) => {
    const { colorBorderActionSecondary, borderWidth2 } = theme();
    const [actionTextVisible, setActionTextVisible] = useState(false);
    useEffect(() => {
        if (!actionTextVisible) {
            return;
        }
        const timeout = setTimeout(() => setActionTextVisible(false), MESSAGE_SHOWN_TIMEOUT);
        return () => clearTimeout(timeout);
    }, [actionTextVisible]);
    const handlePress = useCallback(() => {
        setActionTextVisible(true);
        onPress();
    }, [onPress]);
    const style = useMemo(() => actionButtonStyle({ alignment }), [alignment]);
    const textAnimatedStyle = useAnimatedStyle(() => ({
        opacity: withSpring(status === ActionButtonStatus.ACTIVE || actionTextVisible ? 1 : 0, SPRING_CONFIG),
        transform: [
            {
                translateX: withSpring(status === ActionButtonStatus.ACTIVE || actionTextVisible ? (alignment === "left" ? -16 : 16) : 0, SPRING_CONFIG),
            },
        ],
    }), [actionTextVisible, alignment, status]);
    const buttonAnimatedStyle = useAnimatedStyle(() => ({
        opacity: withSpring(status === ActionButtonStatus.INACTIVE ? 0.3 : 1, SPRING_CONFIG),
        transform: [
            {
                scale: withSpring(status === ActionButtonStatus.ACTIVE ? 1.15 : status === ActionButtonStatus.INACTIVE ? 0.9 : 1, SPRING_CONFIG),
            },
        ],
    }), [status]);
    return (React.createElement(View, { style: style.container },
        React.createElement(Animated.View, { style: [style.textContainer, textAnimatedStyle] },
            React.createElement(Text, { style: style.text, variant: "detail" }, text)),
        React.createElement(TouchableOpacity, { activeOpacity: BUTTON_ACTIVE_OPACITY, testID: testID, onPress: handlePress },
            React.createElement(Animated.View, { style: [style.button, buttonAnimatedStyle] },
                Platform.OS !== "android" && (React.createElement(Svg, { style: style.svg, viewBox: `0 0 ${RADIUS} ${RADIUS}` },
                    React.createElement(Circle, { cx: RADIUS / 2, cy: RADIUS / 2, fill: "none", r: RADIUS / 2 - borderWidth2, stroke: colorBorderActionSecondary, strokeWidth: borderWidth2 }))),
                React.createElement(Icon, { name: icon })))));
};
export { ActionButton, ActionButtonStatus };
